import { commonAPI } from '@/services-ts/axios'
import type {
  IGetBlacklistPostComments,
  IGetBlacklistPosts,
  IPayloadBlacklistRule,
  IUpdateBlackList,
} from '@/types/Request'
import type { IBlacklistStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useBlacklistStore = defineStore('blacklist', {
  state: (): IBlacklistStore => ({
    rules: [],
    posts: [],
    comments: [],
  }),

  actions: {
    async GetBlacklistRuleList() {
      const { data, status } = await commonAPI.BlacklistServices.GetBlacklistRuleList()
      this.rules = status ? data || [] : []
    },

    async CreateBlacklistRule(data: IPayloadBlacklistRule) {
      const { status } = await commonAPI.BlacklistServices.CreateBlacklistRule(data)
      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        await this.GetBlacklistRuleList()
      }
      return status
    },

    async UpdateBlacklistRule(data: IPayloadBlacklistRule) {
      const { status } = await commonAPI.BlacklistServices.UpdateBlacklistRule(data)
      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        await this.GetBlacklistRuleList()
      }
      return status
    },

    async DeleteBlacklistRule(Id: string) {
      const { status } = await commonAPI.BlacklistServices.DeleteBlacklistRule(Id)
      if (status) {
        this.rules = this.rules.filter(item => item.id !== Id)
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async GetBlacklistPostList(payload: IGetBlacklistPosts) {
      const { status, data } = await commonAPI.BlacklistServices.GetBlacklistPostList(payload)
      this.posts = status ? data || [] : []
    },

    async UpdateBlacklistPost(data: IUpdateBlackList[]) {
      const { status } = await commonAPI.BlacklistServices.UpdateBlacklistPost(data)
      if (status) {
        const idSet = new Set(data.map(item => item.Id))
        this.posts = this.posts.filter(item => !idSet.has(item.id))
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async DeleteBlacklistPost(PostIds: string[]) {
      const { status } = await commonAPI.BlacklistServices.DeleteBlacklistPost(PostIds)
      if (status) {
        this.posts = this.posts.filter(item => !PostIds.includes(item.id))
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async GetBlacklistCommentList(payload: IGetBlacklistPostComments) {
      const { status, data } = await commonAPI.BlacklistServices.GetBlacklistCommentList(payload)
      this.comments = status ? data || [] : []
    },

    async UpdateBlacklistComment(data: IUpdateBlackList[]) {
      const { status } = await commonAPI.BlacklistServices.UpdateBlacklistComment(data)

      if (status) {
        const idSet = new Set(data.map(item => item.Id))
        this.comments = this.comments.filter(item => !idSet.has(item.id))
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async DeleteBlacklistComment(PostCommentIds: string[]) {
      const { status } = await commonAPI.BlacklistServices.DeleteBlacklistComment(PostCommentIds)
      if (status) {
        this.comments = this.comments.filter(item => !PostCommentIds.includes(item.id))
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },
  },
})
